import mitt from "mitt";
import Jax from "@bxs/jax";
import { Toast } from "bxs-ui-vue";

// 定义一个空操作函数
const NOOP_FUNC = () => {};

// 创建事件发射器实例，并扩展一次性监听方法
function createEmitter() {
  const inst = mitt();
  inst.once = (type, fn) => {
    inst.on(type, (...args) => {
      fn(...args);
      inst.off(type, fn);
    });
  };
  inst.register = (type, fn) => {    
    inst.on(type, (...args) => {
      fn(...args);
    });
  };
  return inst;
}

// 显示调试通知
function debugNotify(message) {
  Toast({ type: "success", message });
}

// 显示错误通知
function errorNotify(errorMessage) {
  console.error(errorMessage);
  // Toast(errorMessage);
}

// iOS 处理器实现
function getIosHandler() {
  if (!iosHandler) {
    iosHandler = {
      init() {
        iosEmitter = createEmitter();
        window.handleMessageFromBxsTools = (message) => {
          try {
            const { method, data } = JSON.parse(message);
            console.log(`[iosHandler message]: ${message}`);
            iosEmitter.emit(method, data);
          } catch (e) {
            console.error("handleMessageFromBxsTools: ", e, message);
          }
        };
      },

      callHandler(methodName, dataObject, callback) {
        if (typeof window.ReactNativeWebView?.postMessage !== "function") {
          errorNotify("抱歉，您所使用的功能在当前 App 版本不支持");
          console.error(`ios ${methodName}, ${JSON.stringify(dataObject)}`);
          return;
        }
        const message = JSON.stringify({
          method: methodName,
          data: dataObject,
        });
        console.log("androidHandler.callHandler", message);

        window.ReactNativeWebView?.postMessage(message);
        if (methodName === "getScreenRecorderStatus") {
          if (iosEmitter && typeof callback === "function") {
            iosEmitter.register(methodName, callback);
          }
        } else if (iosEmitter && typeof callback === "function") {
          iosEmitter.once(methodName, callback);
        }
      },
    };
  }
  return iosHandler;
}

// Android 处理器实现
function getAndroidHandler() {
  if (!androidHandler) {
    androidHandler = {
      init() {
        androidEmitter = createEmitter();
        window.androidHandler = {
          // callHandler 异步返回
          invokeJsMethod(message) {
            try {
              console.log(
                `[androidHandler message]: ${JSON.stringify(message)}`
              );
              const { method, data } = message;
              androidEmitter.emit(method, data);
            } catch (e) {
              console.error("invokeJsMethod: ", e, message);
            }
          },
          // showScreenRecorder，录屏结束回调
          jsOnBackToInputPage: NOOP_FUNC,
        };
      },

      callHandler(methodName, dataObject, callback) {
        if (typeof window.app?.invokeNativeMethod !== "function") {
          errorNotify("抱歉，您所使用的功能在当前 App 版本不支持");
          return;
        }
        const message = JSON.stringify({
          method: methodName,
          data: dataObject,
        });
        console.log("androidHandler.callHandler", message);
        window.app.invokeNativeMethod(message);
        if (methodName === "getScreenRecorderStatus") {
          if (androidEmitter && typeof callback === "function") {
            androidEmitter.register(methodName, callback);
          }
        } else if (androidEmitter && typeof callback === "function") {
          androidEmitter.once(methodName, callback);
        }
      },
    };
  }
  return androidHandler;
}

// 获取 SDK 处理器
export function getSdkHandler() {
  if (!Jax.isRongYiBaoApp()) {
    return undefined;
  }

  console.log("getSdkHandler", "isIos", Jax.isIos(), navigator.userAgent);

  let handler;
  if (Jax.isIos()) {
    handler = getIosHandler();
  } else if (Jax.isAndroid()) {
    handler = getAndroidHandler();
  }

  if (handler) {
    handler.init();
  }
  return handler;
}

let iosHandler;
let androidHandler;
let iosEmitter;
let androidEmitter;
